import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Navigator from './Navigator'
import FauxButton from './FauxButton'

import '../styles/ActionLinks.css'

class ActionLinks extends Component {
  _renderActionLinks () {
    const {
      links
    } = this.props

    if (links) {
      return links.map((link) => {
        return (
          <Navigator key={link.id} type={link.targetType} id={link.targetId} history={this.props.history}>
            <FauxButton
              label={link.label}
              primary />
          </Navigator>
        )
      })
    }
  }

  render () {
    return (
      <div className='ActionLinks'>
        {this._renderActionLinks()}
      </div>
    )
  }
}

ActionLinks.propTypes = {
  links: PropTypes.array,
  history: PropTypes.object
}

export default ActionLinks



// WEBPACK FOOTER //
// ./src/components/ActionLinks.js